import { Injectable, NgZone } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LoginService } from './login.service'

declare var window:any;

@Injectable({
  providedIn: 'root'
})
export class ListService {
  public list:any = [];
  public showing:any = [];
  public actions:any [];
  public host = 'https://pwa.the-erm.com';
  public family_id = 0;
  public lists:any = [];
  public filterTimeout = null;
  public loaded = false;
  public loading = true;
  public progress = 0;

  public searchText = "";
  public showChecked = 'unchecked';

  constructor(private http:HttpClient,
              private zone:NgZone,
              private router: Router,
              private loginService:LoginService) {

      window.cached = {};
      this.load(true);
      let seconds = 60;
      setInterval(() => { this.load() }, seconds * 1000);
  }

  getParams() {
    let params = "token="+localStorage.token;
    if (typeof localStorage.family_id != 'undefined' && localStorage.family_id) {
        this.family_id = localStorage.family_id;
    }
    if (this.family_id) {
      params += "&family_id="+this.family_id;
    }
    return params;
  }

  startLoading() {
    this.zone.run(() => {
        this.loading = true;
        // this.newItem = "";
    });
  }

  load(clearRemoving:boolean=false) {
    this.startLoading();

    if (!this.loaded) {
      if (typeof localStorage.lists != "undefined") {
        this.lists = JSON.parse(localStorage.lists);
      }
      if (typeof localStorage.list != "undefined") {
        this.list = JSON.parse(localStorage.list);
      }
      if (typeof localStorage.actions != "undefined") {
        this.actions = JSON.parse(localStorage.actions);
      }
      this.loaded = true;
    }

    this.http.post(this.host+"/api/load.php?"+this.getParams(), []).subscribe((res:any[]) => {

        console.log("load res:", res);
        console.log("typeof:", typeof(res));
        if (!res) {
          console.error("no res")
          this.doneLoading();
          return;
        }

        if (res['result'] == "FAIL") {
          if (res['errors'] == "Token not found") {
              this.loginService.logout();
          }
          this.doneLoading();
          return;
        }

        if (res['items']) {
          setTimeout(() =>{
            this.processItems(res['items']);
            if (clearRemoving) {
              for (let j=0;j<this.list.length;j++) {
                this.list[j].removing = false;
              }
            }
          }, 100);
        }
        if (res['family_id']) {
          this.family_id = res['family_id']
          localStorage.family_id = this.family_id;
        }
        if (res['lists']) {
          this.lists = res['lists'];
          localStorage.lists = JSON.stringify(this.lists);
        }
        if (this.actions && this.actions.length > 0) {
          console.log("sendActions()")
          this.sendActions();
        }
        this.doneLoading();

    }, (error) => {
      console.error("error:", error);
      this.doneLoading();
    });
  }

  doneLoading() {
    if (!this.loading) {
      return;
    }
    this.zone.run(() => {
      setTimeout(() => { this.loading = false; }, 2000);
    });
  }

  processItems(items:any) {
    if (!items || items.length == 0) {
      console.warn("processItems no items");
      return;
    }
    window.cached = {};
    if (!this.list) {
        this.list = [];
    }
    let adds = [],
        removes = [];

    // Generate list of new items.
    for (let i=0;i<items.length;i++) {
      let found = false;
      for (let j=0;j<this.list.length;j++) {
        if (items[i].id == this.list[j].id ||
            items[i].name == this.list[j].name) {
            found = true;
            try {
              if (items[i].checked != this.list[j].checked) {
                  this.list[j].checked = items[i].checked;
              }
            } catch(e) {
            console.error("error:",e)
            }
            try {
              if (items[i].qty != this.list[j].qty) {
                  this.list[j].qty = items[i].qty;
              }
            } catch(e) {
            console.error("error:",e)
            }
            try {
              if (items[i].last_time_checked != this.list[j].last_time_checked) {
                  this.list[j].last_time_checked = items[i].last_time_checked;
              }
            } catch(e) {
            console.error("error:",e)
            }
            try {
              if (items[i].id == this.list[j].id) {
                this.list[j].name = items[i].name;
              }
            } catch(e) {
            console.error("error:",e)
            }

            break;
        }
      }
      if (!found) {
        adds.push(items[i]);
      }
    }

    // Remove missing items.
    for (let j=0;j<this.list.length;j++) {
      // Iterate over this.list and find items that aren't in the res.
      let found = false;
      for (let i=0;i<items.length;i++) {
          if (items[i].name == this.list[j].name ||
              ((items[i].id && this.list[j].id) && (items[i].id == this.list[j].id) )
            ) {
            found = true;
            try {
              if (items[i].id != this.list[j].id) {
                this.list[j].id = items[i].id;
              }
            } catch(e) {

            }
            try {
              if (items[i].family_id != this.list[j].family_id) {
                this.list[j].family_id = items[i].family_id;
              }
            } catch(e) {

            }
            try {
              if (items[i].checked != this.list[j].checked) {
                this.list[j].checked = items[i].checked;
              }
            } catch(e) {

            }
            try {
              if (items[i].qty != this.list[j].qty) {
                  this.list[j].checked = items[i].checked;
              }
            } catch(e) {

            }
            break;
          }
      }
      if (!found) {
        removes.push(j);
      }
    }
    console.log("adds:",adds);
    console.log("removes:",removes);
    if (adds.length || removes.length) {
      // Remove from the bottom up.
      removes.reverse();
      for (let i=0;i<removes.length;i++) {
        let idx = removes[i];
        this.list.splice(idx, 1);
      }

      // Add new items.
      for(let i=0;i<adds.length;i++) {
        this.list.push(adds[i]);
      }

      this.sortList();
      // localStorage.list = JSON.stringify(this.list);
    }
    this.showList();
  }

  showList() {
    return;
    // Loop through the items and detrmine if we show it.
    try {
      this.searchText = this.searchText.toLowerCase();
    } catch(e) {
      this.searchText = "";
    }
    let changed = false;
    for (let i=0;i<this.list.length;i++) {
      let item = this.list[i],
          add = false;
      console.log("item:", item);
      if (this.searchText && item.name.toLowerCase().contains(this.searchText)) {
        add = true;
      } else {
        if (this.showChecked == 'all') {
          add = true;
        }
        if (this.showChecked == 'checked' && item.checked) {
          add = true;
        }
        if (this.showChecked == 'unchecked' && !item.checked) {
          add = true;
        }
      }
      /*
        public searchText = "";
        public showChecked = 'all/checked/unchecked';
      */
      let idx = -1;
      for (let j=0;j<this.showing.length;j++) {
        if (this.showing[j].id == item.id) {
          idx = j;
          break;
        }
      }
      if (add && idx == -1) {
        console.log("!found:", item);
        this.zone.run(() => {
          this.showing.push(item);
        });
        changed = true;
      }
      if (!add && idx != -1) {
        console.log("found:", item)
        // this.showing.push(item);
        this.zone.run(() => {
          this.showing.splice(idx,1);
        });
        changed = true;
      }
    }
    if (changed) {

      this.zone.run(() => {
        this.showing = this.showing.sort(function(a, b){
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        console.log("SORT DONE")
      });
    }
    console.log("DONE")
  }

  sortList() {
    this.doSort();
    localStorage.list = JSON.stringify(this.list);
  }

  doSort() {
    this.list.sort((a, b) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
  }

  addItem(newItem) {
    if (!newItem) {
      return;
    }
    const present = this.list.filter((item) => {
      // let lowerI = item.name.toLowerCase().replace(/ \- /g, "");
      //     lowerN = newItem.toLowerCase();
      return item.name.toLowerCase() == newItem.toLowerCase();
    });
    if (present.length == 0) {
      let obj = {"name": newItem};
      this.list.push(obj);
      this.addAction("addItem", obj);
      // points.sort(function(a, b){return a-b});
      this.sortList();
      this.save();
    }
  }

  addAction(action, obj) {
    if (!this.actions) {
      this.actions = [];
    }
    if (typeof obj.evt != "undefined") {
      delete obj.evt;
    }

    this.actions.push({
          "action": action,
          "obj": obj,
          "dt": new Date().toJSON()
    });
    localStorage.actions = JSON.stringify(this.actions);
    this.sendActions();
  }

  deleteItem(item) {
    let yes = confirm("Are you sure you want to delete `"+item.name+"`?");
    if (!yes) {
      return;
    }
    this.list = this.list.filter((_item) => {
      return item.name.toLowerCase() != _item.name.toLowerCase();
    });

    // console.log(this.list);
    this.addAction("deleteItem", item);
    this.save();
  }

  editItem(item:any=null) {
    console.log("editItem:", item)
    item.editing=!item.editing;
    item.tmpName = item.name;
  }

  saveItem(item:any) {
    console.log("saveItem:", item);
    item.editing = false;
    if (item.tmpName &&
        item.tmpName != item.name) {
      item.oldName = item.name;
      item.name = item.tmpName;
      item.newName = item.tmpName;
      this.addAction("renameItem", item);
      this.sortList();
      this.save();
    }
  }

  setQty(item) {
    this.addAction("setQty", item);
    this.save();
  }

  checkItem(item) {

    try {
      if (item.timeout) {
        clearTimeout(item.timeout);
      }
    } catch(e) {

    }
    console.log(item);
    if (!item.checked) {
      // It's been unchecked so don't fade.
      item.removing = false;
      try {
        if (item.timeout) {
          delete item.timeout;
        }
      } catch(e) {

      }
      this.addAction("checkItem", item);
      this.save();
      return;
    }
    item.removing = true;
    item.timeout = setTimeout(() => {
      item.removing = false;
      delete item.timeout;
    }, 5000);
    this.addAction("checkItem", item);
    this.save();
  }

  save() {
    for (let i=0;i<this.list.length;i++) {
      if (typeof this.list[i].evt != "undefined") {
        delete this.list[i].evt;
      }
    }
    this.doSort();
    localStorage.list = JSON.stringify(this.list);
    localStorage.actions = JSON.stringify(this.actions);
    this.sendActions();
  }

  sendActions() {
    if (!this.actions || this.actions.length == 0) {
        return;
    }
    console.log("sendActions():", this.actions);
    this.startLoading();
    this.http.post(this.host+"/api/actions.php?"+this.getParams(), this.actions).subscribe((res:any) => {
        console.log("action res:", res);
        if (res) {
          if (res['processed']) {
            let items = res['processed'];
            this.processActions(items);
          }
          if (res['items']) {
            setTimeout(() =>{
              this.processItems(res['items']);
            }, 100);
          }
        }
        this.doneLoading();
    }, (error) => {
      console.error("error:", error);
      this.doneLoading();
    });
  }

  processActions(items) {
    if (!items || items.length == 0) {
      return;
    }
    let foundOneItem = false;
    this.actions = this.actions.filter((aitem) => {
      let found = false;
      for(let i=0;i<items.length;i++) {
        let ritem = items[i];
        found = ritem.action == aitem.action && aitem.dt == ritem.dt;
        if (found) {
          console.log("found");
          foundOneItem = true;
          break;
        }
      }
      return !found;
    });
    console.log("actions:", this.actions);
    localStorage.actions = JSON.stringify(this.actions);

  }

  makeid(length) {
     let result           = 'TMP_',
         characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
         charactersLength = characters.length;
     if (!length) {
       length = 10;
     }
     for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }

  createList(name) {
    // this.lists.push({"name": name});
    // TODO figure out how to handle new lists
    /*
      They have to get an id, but what do I do if they aren't connected to the web?
    */
  }


}
